"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._DeletedObject = {
    type: "structure",
    required: [],
    members: {
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        VersionId: {
            shape: {
                type: "string"
            }
        },
        DeleteMarker: {
            shape: {
                type: "boolean"
            }
        },
        DeleteMarkerVersionId: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_DeletedObject.js.map